import React from 'react';
import QRCode from 'qrcode.react'

function Qrcode() {
  return (
      <div>
           <QRCode value="http://localhost:3000/1" />,
           {/* <QRCode value="http://localhost:3000/2" />,
           <QRCode value="http://localhost:3000/3" />,
           <QRCode value="http://localhost:3000/4" />,
           <QRCode value="http://localhost:3000/5" />,
           <QRCode value="http://localhost:3000/6" />,
           */}
           
      </div>
  )
}

export default Qrcode;
